import {
  combinedStatusTone,
  formatStatusLabel,
  type RawStatus,
  type StatusTone,
  type VerificationStatusMap,
} from "../../../types/documents";

interface ExtractionStageChipProps {
  status: RawStatus | null | undefined;
  /**
   * Optional verification map for the row — when supplied the chip
   * also reflects the verification state, e.g. it flips green once
   * every reviewable code (TV / BC) is signed off, or red if any of
   * them rejected. Without this prop the chip falls back to the raw
   * status tone (used wherever the row is shown without verification
   * context, e.g. in toasts).
   */
  verification?: VerificationStatusMap;
}

const TONE_CLASS: Record<StatusTone, string> = {
  ok: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  running: "bg-blue-50 text-blue-700 ring-blue-200",
  warn: "bg-amber-50 text-amber-700 ring-amber-200",
  fail: "bg-rose-50 text-rose-700 ring-rose-200",
  neutral: "bg-gray-100 text-gray-700 ring-gray-200",
};

export function ExtractionStageChip({
  status,
  verification,
}: ExtractionStageChipProps) {
  const tone = combinedStatusTone(status, verification);
  const label = formatStatusLabel(status);

  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${TONE_CLASS[tone]}`}
      title={status ?? ""}
    >
      {label}
    </span>
  );
}
